import React from 'react';
import HelpComponent from '../Components/Help.jsx';

export default function HelpView(){
    return(
        <HelpComponent
            done={() => {window.history.back()}}
            back={() => {window.history.back()}}/>
    )
}